<template>
<span class="d-flex">
	U = {{ eventPayload[eventSchema.payload.allowed.value.key].toFixed(2) }}
	({{ eventSchema.payload.allowed.minTrashold.title }} = {{ eventPayload[eventSchema.payload.allowed.minTrashold.key] }}, 
	{{ eventSchema.payload.allowed.maxTrashold.title }} = {{ eventPayload[eventSchema.payload.allowed.maxTrashold.key] }})
</span>
</template>



<script>
import { capitalizeFirstLetter } from '@/helpers.js'
import {
	eventSchema,
 } from '@/composables/events.js'


export default {
	components: {},
	
	props: {
		[eventSchema.payload.allowed.value.key]: {
			type: Number,
			required: true,
		},
		[eventSchema.payload.allowed.minTrashold.key]: {
			type: Number,
			required: true,
		},
		[eventSchema.payload.allowed.maxTrashold.key]: {
			type: Number,
			required: true,
		},
	},

	setup() {
		return {
			capitalizeFirstLetter,
			eventSchema,
		}
	},

	methods: {},

	computed: {
		eventPayload() {
			return this.$props
		}
	},
}
</script>